import { Modal } from "./Modal";

// "What is JSONL?" explainer dialog, opened from the home page info links and the
// #what-is-jsonl hash.
export function JsonlModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal onClose={onClose}>
      <h2>What is JSONL?</h2>
      <p>
        <strong>JSONL</strong> (JSON Lines) is a text format where each line is a
        valid JSON object. Unlike standard JSON arrays, JSONL doesn't require
        wrapping objects in brackets or separating them with commas.
      </p>

      <h3>Why is it useful?</h3>
      <ul>
        <li>
          <strong>Streaming:</strong> Process data line by line without loading
          the entire file into memory
        </li>
        <li>
          <strong>Append-friendly:</strong> Add new records by simply appending
          lines to a file
        </li>
        <li>
          <strong>Error resilience:</strong> A malformed line doesn't break the
          entire file
        </li>
        <li>
          <strong>Simple parsing:</strong> Read one line, parse one JSON object
        </li>
      </ul>

      <h3>Example</h3>
      <pre>
        {`{"name": "Alice", "age": 30}
{"name": "Bob", "age": 25}
{"name": "Charlie", "age": 35}`}
      </pre>

      <h3>Common Use Cases</h3>
      <ul>
        <li>Log files and application event streams</li>
        <li>Data export/import for large datasets</li>
        <li>Machine learning training data</li>
        <li>Database dumps and migrations</li>
        <li>API response streaming</li>
        <li>Analytics and metrics collection</li>
        <li>
          <strong>Anthropic / Claude Code:</strong> Claude Code stores
          conversation history and project data in JSONL format in{" "}
          <code>~/.claude/projects/</code>
        </li>
      </ul>
    </Modal>
  );
}

export default JsonlModal;
